import React from "react";
import { Modal } from "react-bootstrap";
import { connect } from "react-redux";
import * as actionCreators from "../../../action/index.js";
import { updateAlertMessage } from "../../../helpers/common/helperConstant.js";

class AlertBox extends React.Component {
  handleClose = (alertUsedFor, isDone) => {
    const { submitCheckoutBtn } = this.props.const_var;
    this.props.const_var.submitCheckoutBtn = false;
    isDone ? this.props.alertDone(alertUsedFor) : this.props.alertCancel(alertUsedFor);
  };

  custom = () => {
    const modalElement = document.querySelector(".modal");
    let boxFlag = false
    if (modalElement) {
      modalElement.style.transform = "scale(0)";
      modalElement.style.transition = "0.6s";
      if(this.props.const_var.alertUsedFor == "YourCanNotAddLeanTo"){
         boxFlag = true
      }
      setTimeout(() => {
        this.handleClose(this.props.const_var.alertUsedFor, boxFlag);
      }, 500);
    }
  };

  submitClick = () => {
    const modalElement = document.querySelector(".modal");
    if(this.props.const_var.alertUsedFor === "stateManuApiError") {
      this.props.handleCompanySelection(this.props.const_var.companyIdSelectedFromStateScreen)
    }

    if (modalElement) {
      modalElement.style.transform = "scale(0)";
      modalElement.style.transition = "0.6s";
      setTimeout(() => {
        this.handleClose(this.props.const_var.alertUsedFor, true);
      }, 300);
    }
  }

  getButtonStyles = () => {
    const { alertUsedFor } = this.props.const_var;
    const { checkKey } = this.props;

    const isNoSpaceAlert = [
      "noSpaceToAddCupola",
      "noSpaceToUpdateCupola",
      "endLeantosForTubulerBuildingMnf",
      "endLeantoPorchessForTubulerBuildingMnf",
      "notAllowInsulationForHorizontalOrRegularRoof"
    ].includes(alertUsedFor);

    const shouldShowCancelButton = ![
      "YouCanNotIncreaseHeight",
      "YourCanNotAddLeanTo",
      "noSpaceForComponentDuringLoading",
      "YouCanNotAddPorch",
      "showOverheadOldQuoteOrderMsg",
      "restrictedBuildingHeight",
      "restrictedBuildingHeight1",
      "ShowPromptForApplyDiscount"
    ].includes(checkKey);

    return {
      isNoSpaceAlert,
      shouldShowCancelButton
    };
  };

  render() {
    const { isShowAlert, alertUsedFor } = this.props.const_var;
    const { shouldShowCancelButton, isNoSpaceAlert } = this.getButtonStyles();
    return (
      <Modal
        centered
        show={isShowAlert}
        dialogClassName="new-alert-modal react-modal"
        backdrop="static"
        keyboard={false}
        onHide={this.props.handleClose}
      >
        <button
          className={`close ${["captuareIMG", "noSpaceToAddCupola", "noSpaceToUpdateCupola", "endLeantosForTubulerBuildingMnf", "endLeantoPorchessForTubulerBuildingMnf", "NoMfgExsist","notAllowInsulationForHorizontalOrRegularRoof","stateManuApiError"].includes(alertUsedFor) ? "d-none" : ""}`}
          onClick={this.custom}
        >
          <span className="icon-close"></span>
        </button>
        <Modal.Body>
          <h5 className="modal-title">Alert</h5>
          <div className={`row ${alertUsedFor == 'NoMfgExsist' ? 'mb-5' : ''}`}>
            <div className="col-12">
              <p>{updateAlertMessage(alertUsedFor)}</p>
            </div>
          </div>
          <div className={`alert-footer ${alertUsedFor == 'NoMfgExsist' ? ' d-none' : ''}`}>
            {shouldShowCancelButton && (
              <button
                onClick={this.custom}
                className={`btn ${this.props.checkKey !== "RegularRoofStyle" && this.props.checkKey != "RegularRoofStyleTextureChange" ? 'btn btn-default' : 'btn btn-primary'} ${["captuareIMG", "noSpaceToAddCupola", "noSpaceToUpdateCupola", "endLeantosForTubulerBuildingMnf", "endLeantoPorchessForTubulerBuildingMnf", "NoMfgExsist","notAllowInsulationForHorizontalOrRegularRoof","stateManuApiError", "DoorHeightGreaterThanLentoHeight"].includes(alertUsedFor) ? "d-none" : ""}`}
              >
                <span className="text">
                  {this.props.checkKey !== "RegularRoofStyle" && this.props.checkKey != "RegularRoofStyleTextureChange" ? this.props.const_var.alertUsedFor == "changeInstallationSurface"?'Keep Surface':'Cancel':'Done'}
                </span>
              </button>
            )}

            {this.props.checkKey !== "RegularRoofStyle" && this.props.checkKey != "RegularRoofStyleTextureChange" && alertUsedFor != 'NoMfgExsist' && (
              <button
                onClick={this.submitClick}
                className="btn btn-primary"
              >
                <span className="text">
                {["captuareIMG", "noSpaceToAddCupola", "noSpaceToUpdateCupola", "NoMfgExsist", "notAllowInsulationForHorizontalOrRegularRoof","YouCanNotIncreaseHeight","stateManuApiError", "DoorHeightGreaterThanLentoHeight"].includes(alertUsedFor) ? "Ok" : this.props.const_var.alertUsedFor == "changeInstallationSurface" ? 'Remove Door': 'Done'}
                </span>
              </button>
            )}
          </div>
        </Modal.Body>
      </Modal>
    );
  }
}

const mapStoreToProps = (state) => state.reducer;

export default connect(mapStoreToProps, actionCreators)(AlertBox);
